/*
==========================================================
Project : ChemMaster SA
File    : aiTutorService.js
Version : 1.0
Purpose : Sends authenticated ChemMaster Tutor requests
          from React to the Express backend.
==========================================================
*/

import { API_BASE_URL } from "../apiConfig";

export async function startAITutorSession(
  sessionSettings
) {
  const token = localStorage.getItem(
    "chemMasterToken"
  );

  if (!token) {
    throw new Error(
      "Your login session could not be found. Please sign in again."
    );
  }

  const response = await fetch(
    `${API_BASE_URL}/ai-tutor/start-session`,
    {
      method: "POST",

      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },

      body: JSON.stringify(sessionSettings),
    }
  );

  const data = await response.json();

  if (!response.ok) {
    throw new Error(
      data.message ||
      "The AI Tutor session could not be started."
    );
  }

  return data;
}

export async function answerAITutorQuestion(
  answerPayload
) {
  const token = localStorage.getItem(
    "chemMasterToken"
  );

  if (!token) {
    throw new Error(
      "Your login session could not be found. Please sign in again."
    );
  }

  const response = await fetch(
    `${API_BASE_URL}/ai-tutor/answer-question`,
    {
      method: "POST",

      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },

      body: JSON.stringify(answerPayload),
    }
  );

  const data = await response.json();

  if (!response.ok) {
    throw new Error(
      data.message ||
      "The AI Tutor answer could not be marked."
    );
  }

  return data;
}
